var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 450 c-14 -12 -38 -20 -62 -20 -37 0 -39 -1 -39 -33 0 -25 -9 -42 -35 -67 l-35 -34 0 -133 0 -133 220 0 220 0 0 133 0 133 -35 34 c-26 25 -35 42 -35 67 0 32 -2 33 -39 33 -23 0 -48 8 -64 20 -32 25 -65 25 -96 0z m74 -10 c4 -6 -7 -10 -25 -10 -18 0 -29 4 -25 10 3 6 15 10 25 10 10 0 22 -4 25 -10z m105 -119 c0 -86 -1 -90 -27 -109 l-27 -20 -38 21 -38 22 -38 -22 -38 -21 -27 20 c-26 19 -27 23 -27 109 l0 89 130 0 130 0 0 -89z m-280 -33 l0 -42 -22 21 c-21 22 -21 23 -3 43 10 11 20 20 22 20 1 0 3 -19 3 -42z m322 -20 l-22 -22 0 44 0 44 22 -22 22 -22 -22 -22z m-304 -57 l42 -33 -49 -39 c-27 -21 -52 -39 -55 -39 -3 0 -6 37 -6 81 0 64 3 79 13 72 6 -5 31 -24 55 -42z m328 -108 c-3 -3 -28 13 -56 35 l-51 41 53 40 53 40 3 -76 c2 -41 1 -78 -2 -80z m-90 37 c49 -39 91 -75 92 -80 2 -6 -69 -10 -198 -10 -129 0 -200 4 -198 10 6 17 181 150 198 150 9 0 57 -32 106 -70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 350 c0 -6 40 -10 100 -10 60 0 100 4 100 10 0 6 -40 10 -100 10 -60 0 -100 -4 -100 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 300 c0 -6 28 -10 65 -10 37 0 65 4 65 10 0 6 -28 10 -65 10 -37 0 -65 -4 -65 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letter_icon.df746fcd5ad8e93696ebf7056e2d1b73.svg";
export { ForwardRef as ReactComponent };